import { NgModule } from '@angular/core';
import { MaterialModule } from '@material/material.module';
import { PaymentModule } from '@payment/payment.module';
import { PPTContactBidderComponent } from '@/app/modules/ppt/pages/bill/components/dialogs/contact-bidder/contact-bidder.component';
import { ParcelDetailsComponent } from '@/app/modules/ppt/pages/bill/components/parcel-details/parcel-details.component';
import { ParcelHistoryComponent } from '@/app/modules/ppt/pages/bill/components/parcel-history/parcel-history.component';
import { BillActionsComponent } from '@/app/modules/ppt/pages/bill/components/ppt-bill-actions/ppt-bill-actions.component';
import { BillPage } from '@/app/modules/ppt/pages/bill/ppt-bill.component';
import { SharedModule } from '@shared/shared.module';
import { PPTBillPaidComponent } from './components/data/bill-paid/ppt-bill-paid.component';
import { PPTBillStatusComponent } from './components/data/bill-status/ppt-bill-status.component';
import { PPTOwnerComponent } from './components/data/owner/ppt-owner.component';
import { PPTPaidOnComponent } from './components/data/paid-on/ppt-paid-on.component';
import { PPTPaymentAmountComponent } from './components/data/payment-amount/ppt-payment-amount.component';
import { PPTPaymentStatusComponent } from './components/data/payment-status/ppt-payment-status.component';
import { PPTPayorComponent } from './components/data/payor/ppt-payor.component';
import { PPTReceiptNumberComponent } from './components/data/receipt-number/ppt-receipt-number.component';
import { PPTTaxYearComponent } from './components/data/tax-year/ppt-tax-year.component';
import { ParcelResultsComponent } from './components/results/ppt-lookup-results.component';
import { PPTRoutingModule } from './ppt-routing.module';
import { PPTAccountBalanceComponent } from './components/data/account-balance/account-balance.component';


@NgModule({
    declarations:
    [
        BillActionsComponent,
        BillPage,
        PPTContactBidderComponent,
        ParcelHistoryComponent,
        ParcelDetailsComponent,
        PPTTaxYearComponent,
        PPTOwnerComponent,
        PPTBillStatusComponent,
        PPTPaymentStatusComponent,
        PPTReceiptNumberComponent,
        PPTPayorComponent,
        PPTPaidOnComponent,
        PPTPaymentAmountComponent,
        PPTBillPaidComponent,
        ParcelResultsComponent,
        PPTAccountBalanceComponent,
    ],
    imports:
    [
        SharedModule,
        MaterialModule,

        PPTRoutingModule,

        PaymentModule,
    ],
    exports:
    [
        ParcelResultsComponent,
        PPTAccountBalanceComponent,
    ],
})
export class PPTModule {}
